import { useEffect, useContext } from 'react'
import { FileUploader } from "react-drag-drop-files"
import _ from 'lodash'

import { Typography, TextField, Stack, Switch } from '@mui/material'

import { AppContext } from '/providers/app-context'
import { uploadClientImage } from '/providers/templates-api'

const StampConfig = ({ setPrevButtonState, setNextButtonState, scannerData, setScannerData, templateId, clientId }) => {

  const { apiSource, apiKeys, setProcessing } = useContext(AppContext)
  
  useEffect(() => {
    setPrevButtonState("enabled")
    setNextButtonState("disabled")
  }, [])

  useEffect(() => {
    let enabled = true

    if (!scannerData.logo.length) enabled = false
    if (!scannerData.retailer_name.length) enabled = false
    if (!scannerData.title.length) enabled = false
    if (!scannerData.description.length) enabled = false
    if (!scannerData.stamps_per_card > 0) enabled = false
    if (!Number.isInteger(parseInt(scannerData.initial_stamps,10)) || scannerData.initial_stamps >= scannerData.stamps_per_card) enabled = false

    setNextButtonState(enabled ? "enabled" : "disabled")
  },[scannerData])

  const handleImageUpload = file => {
    const filename = file.name

    const reader = new FileReader()
    reader.onloadend = async () => {
      const s3_url = await doUploadToS3(filename, reader.result)

      let sd = _.cloneDeep(scannerData)
      _.set(sd, "logo", s3_url)
      setScannerData(sd)
    }
    reader.readAsDataURL(file)
  }

  const doUploadToS3 = async (filename, imageData) => {
    const base64Data = imageData.replace(/^data:image\/\w+;base64,/, '')
    setProcessing(true)
    const response = await uploadClientImage({ apiSource, apiKeys, device:"scan", imageType:"logo", filename, base64Data })
    //TODO handler error

    setProcessing(false)

    return response.s3_url
  }

  const setNumericValue = (value, field) => setValue(value.replace(/[^0-9]/g, ""), field)

  const setValue = (value, field) => {
    let sd = _.cloneDeep(scannerData)
    _.set(sd, field, value)
    setScannerData(sd)
  }

  return (
    <>
      <Typography variant="h3" sx={{ p: 2 }}>Configure Stampcard</Typography>

      <div className='flex flex-col gap-5 mb-5'>
        <Typography variant="h5" sx={{ p: 2 }}>Logo Image</Typography>

        <div className='bg-white'>
          <img src={scannerData.logo} style={{ margin: "auto", marginTop: 10, marginBottom: 10 }} />
        </div>

        <FileUploader handleChange={handleImageUpload} types={["png", "jpg", "jpeg"]} label="Click to select image, or drag an image here (1200x400)" />

        <Typography variant="h5" sx={{ p: 2 }}>Promotion Details</Typography>

        <TextField label="Retailer Name" value={scannerData.retailer_name} onChange={e => setValue(e.target.value, "retailer_name")} type="search" slotProps={{ inputLabel: { shrink: true } }} />
        <TextField label="Promotion Title" value={scannerData.title} onChange={e => setValue(e.target.value, "title")} type="search" slotProps={{ inputLabel: { shrink: true } }} />
        <TextField label="Promotion Description" value={scannerData.description} onChange={e => setValue(e.target.value, "description")} multiline={true} minRows={5} slotProps={{ inputLabel: { shrink: true } }} />

        <Typography variant="h5" sx={{ p: 2 }}>Collection settings</Typography>
        <TextField label="Number of stamps per card" value={scannerData.stamps_per_card} onChange={e => setNumericValue(e.target.value, "stamps_per_card")} type="search" slotProps={{ inputLabel: { shrink: true } }} />
        <TextField label="Number of free starter stamps" value={scannerData.initial_stamps} onChange={e => setNumericValue(e.target.value, "initial_stamps")} type="search" slotProps={{ inputLabel: { shrink: true } }} />

        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <div className="flex flex-row gap-5 justify-between">
            <Typography>Allow multiple cards to be filled before redeeming?:</Typography>
            <div className="flex flex-row gap-5 justify-between">
              <Typography>No</Typography>
              <Switch checked={scannerData.multiple_cards_permitted} onChange={e => setValue(e.target.checked, "multiple_cards_permitted")} />
              <Typography>Yes</Typography>
            </div>
          </div>
        </Stack>
      </div>
    </>
  )
}

export default StampConfig